"use client";

import { FormProvider, useWvcForm } from "@/integrations/forms/FormProvider";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Form, FormControl, FormField, FormItem, FormLabel, FormMessage } from "@/components/ui/form";
import { Loader } from "lucide-react";
const directoryEntries = [{
  label: "ADDRESS",
  value: "Wilge rd., Golfpark, Gauteng, South Africa, 1961"
}, {
  label: "TELEPHONE",
  value: "082 553 8657"
}, {
  label: "CORRESPONDENCE",
  value: "charles@imcncdesigns.co.za"
}, {
  label: "HOURS",
  value: "Monday through Friday, 8 — 5"
}, {
  label: "SUPPORT",
  value: "24/7 Emergency Siemens Support"
}];
function ReachOutForm() {
  const {
    isSubmitting,
    isSubmitted,
    submitError,
    successMessage,
    handleSubmit,
    resetForm,
    control
  } = useWvcForm();
  if (isSubmitted && !submitError) {
    return <div className="border-t border-b border-[var(--border)] py-12">
        <p className="font-mono text-xs uppercase tracking-[0.18em] text-[var(--muted-foreground)] mb-4">
          N° — INQUIRY RECEIVED
        </p>
        <p className="text-foreground text-xl font-light leading-snug mb-8">
          {successMessage}
        </p>
        <Button onClick={resetForm} variant="outline" className="border border-[var(--primary)] bg-transparent text-[var(--primary)] hover:bg-[var(--primary)] hover:text-white px-9 py-5 h-auto font-default tracking-[0.04em]">
          Send another inquiry
        </Button>
      </div>;
  }
  return <Form onSubmit={handleSubmit} className="space-y-10">
      <FormField control={control} name="full_name" rules={{
      required: "Full name is required"
    }} render={({
      field
    }) => <FormItem className="grid gap-3">
            <FormLabel className="font-mono text-[11px] uppercase tracking-[0.18em] text-[var(--muted-foreground)] font-normal">
              Full Name
            </FormLabel>
            <FormControl>
              <Input placeholder="e.g., John Doe" {...field} className="border-0 border-b border-[var(--border)] bg-transparent px-0 py-4 h-auto text-base text-foreground focus-visible:ring-0 focus-visible:border-[var(--primary)] placeholder:text-[var(--muted-foreground)]/50" />
            </FormControl>
            <FormMessage />
          </FormItem>} />

      <FormField control={control} name="company_name" render={({
      field
    }) => <FormItem className="grid gap-3">
            <FormLabel className="font-mono text-[11px] uppercase tracking-[0.18em] text-[var(--muted-foreground)] font-normal">
              Company Name
            </FormLabel>
            <FormControl>
              <Input placeholder="e.g., Industrial Solutions Ltd" {...field} className="border-0 border-b border-[var(--border)] bg-transparent px-0 py-4 h-auto text-base text-foreground focus-visible:ring-0 focus-visible:border-[var(--primary)] placeholder:text-[var(--muted-foreground)]/50" />
            </FormControl>
            <FormMessage />
          </FormItem>} />

      <FormField control={control} name="email" rules={{
      required: "Email address is required",
      pattern: {
        value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
        message: "Please enter a valid email"
      }
    }} render={({
      field
    }) => <FormItem className="grid gap-3">
            <FormLabel className="font-mono text-[11px] uppercase tracking-[0.18em] text-[var(--muted-foreground)] font-normal">
              Email Address
            </FormLabel>
            <FormControl>
              <Input type="email" placeholder="you@company.com" {...field} className="border-0 border-b border-[var(--border)] bg-transparent px-0 py-4 h-auto text-base text-foreground focus-visible:ring-0 focus-visible:border-[var(--primary)] placeholder:text-[var(--muted-foreground)]/50" />
            </FormControl>
            <FormMessage />
          </FormItem>} />

      <FormField control={control} name="phone" render={({
      field
    }) => <FormItem className="grid gap-3">
            <FormLabel className="font-mono text-[11px] uppercase tracking-[0.18em] text-[var(--muted-foreground)] font-normal">
              Telephone
            </FormLabel>
            <FormControl>
              <Input type="tel" placeholder="082 553 8657" {...field} className="border-0 border-b border-[var(--border)] bg-transparent px-0 py-4 h-auto text-base text-foreground focus-visible:ring-0 focus-visible:border-[var(--primary)] placeholder:text-[var(--muted-foreground)]/50" />
            </FormControl>
            <FormMessage />
          </FormItem>} />

      <FormField control={control} name="message" rules={{
      required: "Please describe your Siemens parts requirement",
      minLength: {
        value: 10,
        message: "Message must be at least 10 characters"
      }
    }} render={({
      field
    }) => <FormItem className="grid gap-3">
            <FormLabel className="font-mono text-[11px] uppercase tracking-[0.18em] text-[var(--muted-foreground)] font-normal">
              Requirement Details
            </FormLabel>
            <FormControl>
              <Textarea rows={4} placeholder="Specify Siemens part numbers or service needs..." {...field} className="border-0 border-b border-[var(--border)] bg-transparent px-0 py-4 min-h-0 text-base text-foreground resize-none focus-visible:ring-0 focus-visible:border-[var(--primary)] placeholder:text-[var(--muted-foreground)]/50" />
            </FormControl>
            <FormMessage />
          </FormItem>} />

      {submitError && <div className="border-t border-b border-[var(--destructive)] py-4">
          <p className="font-mono text-xs uppercase tracking-[0.18em] text-[var(--destructive)]">
            {submitError}
          </p>
        </div>}

      <div className="pt-4">
        <Button type="submit" disabled={isSubmitting} className="bg-[var(--primary)] text-white hover:bg-[var(--secondary)] px-9 py-5 h-auto text-base font-default tracking-[0.04em] w-full sm:w-auto">
          {isSubmitting ? <>
              <Loader className="animate-spin mr-2 size-4" />
              Sending
            </> : "Submit Inquiry"}
        </Button>
        <p className="mt-6 font-mono text-[11px] uppercase tracking-[0.18em] text-[var(--muted-foreground)]">
          We respond to all Siemens parts inquiries within 24 hours.
        </p>
      </div>
    </Form>;
}
export default function Partsinquirycontact() {
  return <section data-section-id="1613" id="partsinquirycontact" className="bg-background py-24 md:py-32 lg:py-44 border-t border-b border-[var(--border)] overflow-hidden">
      <div className="max-w-[1440px] mx-auto px-6 md:px-16 lg:px-24">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-y-16 lg:gap-x-8">
          <div className="lg:col-span-5 relative">
            <div className="lg:sticky lg:top-32">
              <p className="font-mono text-xs uppercase tracking-[0.18em] text-[var(--muted-foreground)]">
                N° 01 — CONTACT US
              </p>

              <div className="relative mt-14">
                <span aria-hidden="true" className="pointer-events-none absolute -top-12 right-0 select-none font-default font-light text-[14rem] md:text-[18rem] lg:text-[22vw] leading-none text-[var(--border)]/30" style={{
                WebkitTextStroke: "1px var(--border)",
                color: "transparent"
              }}>
                  01
                </span>
                <h1 className="font-default relative text-foreground font-extralight leading-[1.02] tracking-tight text-[clamp(2.25rem,4.8vw,4.75rem)]">
                  Siemens <em className="italic font-extralight">Parts</em> Inquiry.
                </h1>
              </div>

              <div className="mt-16 border-t border-[var(--border)]">
                {directoryEntries.map((entry, i) => <div key={i} data-index={i} className="grid grid-cols-12 gap-4 py-8 border-b border-[var(--border)]">
                    <p className="col-span-12 sm:col-span-4 font-mono text-[11px] uppercase tracking-[0.18em] text-[var(--muted-foreground)] pt-1">
                      {entry.label}
                    </p>
                    <p className="col-span-12 sm:col-span-8 font-default font-light text-foreground text-[clamp(1.125rem,1.4vw,1.375rem)] leading-snug">
                      {entry.value}
                    </p>
                  </div>)}
              </div>

              <p className="mt-12 font-mono text-[11px] uppercase tracking-[0.18em] text-[var(--muted-foreground)]">
                IM CNC DESIGNS — SIEMENS SPECIALISTS
              </p>
            </div>
          </div>

          <div className="lg:col-span-7 lg:pl-8 xl:pl-16">
            <FormProvider formKey="contact_inquiry_form_contact_us" formId="contact_inquiry_form_contact_us" sectionName="partsinquirycontact" defaultValues={{
            full_name: "",
            company_name: "",
            email: "",
            phone: "",
            message: ""
          }} validationRules={{
            full_name: {
              required: true
            },
            email: {
              required: true,
              pattern: "email"
            },
            phone: {
              pattern: "phone"
            },
            message: {
              required: true,
              minLength: 10
            }
          }} submitText="Submit Inquiry" successMessage="Thank you. Our team will review your Siemens parts request shortly." errorMessage="We could not send your inquiry. Please try again.">
              <ReachOutForm />
            </FormProvider>
          </div>
        </div>
      </div>
    </section>;
}